import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { AffiliateButton, ScoreBadge } from "./Affiliate";
import { VpnLogo } from "./VpnLogo";
import { Reveal } from "./motion";

export const VpnCard = ({ vpn, index = 0 }) => {
  const isNord = vpn.slug === "nordvpn";
  return (
    <Reveal delay={index * 0.06}>
      <div
        data-testid={`vpn-card-${vpn.slug}`}
        className={`group relative flex flex-col gap-6 border p-8 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg sm:flex-row sm:items-center ${
          isNord ? "border-[#4687FF] bg-[#4687FF]/[0.04] shadow-[0_0_0_1px_#4687FF]" : "border-slate-200 bg-white"
        }`}
      >
        {isNord && (
          <div className="absolute -top-3.5 left-8 flex items-center gap-1.5 bg-[#4687FF] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em] text-white">
            <Trophy size={12} /> Editor's Choice
          </div>
        )}
        <div className="flex items-center gap-5">
          <span className="font-display text-4xl font-black tracking-tighter text-slate-200">
            {String(vpn.rank).padStart(2, "0")}
          </span>
          <VpnLogo vpn={vpn} size={72} />
          <ScoreBadge score={vpn.score} />
        </div>
        <div className="flex-1">
          <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <h3 className="font-display text-2xl font-extrabold tracking-tight text-[#0F172A]">{vpn.name}</h3>
            <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#4687FF]">{vpn.badge}</span>
          </div>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-600">{vpn.blurb}</p>
          <Link
            to={`/reviews/${vpn.slug}`}
            data-testid={`vpn-card-review-link-${vpn.slug}`}
            className="mt-2 inline-block text-xs font-semibold text-[#4687FF] underline underline-offset-4 hover:text-[#2563eb]"
          >
            Read full {vpn.name} review →
          </Link>
        </div>
        <div className="flex shrink-0 flex-col items-start gap-2 sm:items-end">
          <span className="font-display text-sm text-slate-500">
            from <span className="text-xl font-extrabold text-[#0F172A]">{vpn.price}</span>/mo
          </span>
          <AffiliateButton href={vpn.link} testId={`vpn-card-cta-${vpn.slug}`} variant={isNord ? "primary" : "dark"}>
            {vpn.cta}
          </AffiliateButton>
        </div>
      </div>
    </Reveal>
  );
};
